{
  "blocks": [],
  "relationships": [],
  "localeVariants": [
    {
      "id": "moon-article-embryo-freezing",
      "locale": "fr",
      "variant": {
        "title": "Qu'est-ce que la congélation d'embryons, exactement ?",
        "subtitle": "La science derrière la préservation de ta future famille.",
        "body": {
          "introduction": "Pour commencer",
          "quickSummary": [
            {
              "title": "Une technologie éprouvée.",
              "description": "La congélation d'embryons fonctionne depuis 1984, avec la vitrification moderne atteignant plus de 95 % de survie après décongélation."
            },
            {
              "title": "Une décision partagée.",
              "description": "Les embryons nécessitent le consentement de la donneuse d'ovocyte et du donneur de sperme pour leur usage, conservation, ou destruction."
            },
            {
              "title": "Pas de date d'expiration.",
              "description": "Les embryons peuvent être conservés indéfiniment sans preuve que la durée affecte les résultats."
            }
          ],
          "sections": [
            {
              "title": "Qu'est-ce que la cryoconservation ?",
              "content": "La congélation d'embryons (cryoconservation) consiste à féconder des ovocytes avec du sperme, à faire grandir les embryons obtenus jusqu'au stade blastocyste (jour 5 ou 6), puis à les vitrifier pour une conservation longue durée. C'est l'une des technologies de procréation médicalement assistée les mieux établies, avec la première grossesse réussie à partir d'un embryon congelé rapportée en 1984.",
              "bulletPoints": [
                "Les embryons sont cultivés jusqu'au stade blastocyste (jour 5 ou 6) avant congélation",
                "Contrairement à la congélation d'ovocytes, demande une source de sperme (partenaire ou donneur)",
                "Taux de survie après décongélation plus élevés que les ovocytes congelés"
              ]
            },
            {
              "title": "Comment fonctionne la fécondation",
              "content": "Contrairement à la congélation d'ovocytes, la congélation d'embryons demande une source de sperme (partenaire ou donneur). L'avantage est que les embryons ont des taux de survie légèrement plus élevés après décongélation, et tu peux les tester pour des anomalies chromosomiques (PGT-A) avant de décider lequel transférer."
            },
            {
              "title": "Le processus en laboratoire",
              "content": "Le processus est identique à celui de la congélation d'ovocytes jusqu'à la ponction. Après ça, le laboratoire d'embryologie prend le relais : fécondation, culture, classification, et test génétique en option. Tu auras généralement des nouvelles de ta clinique au jour 1 (vérification de la fécondation), au jour 3 (division cellulaire), et au jour 5 ou 6 (formation du blastocyste).",
              "diagram": {
                "label": "Processus de vitrification"
              }
            },
            {
              "title": "La vitrification moderne",
              "content": "La vitrification (la technique de congélation flash utilisée aujourd'hui) est une avancée majeure par rapport aux méthodes de congélation lente du passé. Elle empêche la formation de cristaux de glace à l'intérieur des cellules, qui abîmait les embryons pendant la congélation. Les taux de survie modernes après décongélation dépassent 95 % dans la plupart des cliniques."
            },
            {
              "title": "Considérations légales en France",
              "content": "En France, les embryons ne sont pas considérés comme une « propriété » mais relèvent d'un dispositif d'autorisation parentale conjointe (article L2141-3 du Code de la santé publique). Concrètement, l'usage, la conservation, le don ou la destruction des embryons surnuméraires nécessitent le consentement écrit des deux membres du couple. En cas de séparation, de désaccord ou de décès d'un·e des partenaires, le transfert ne peut pas avoir lieu sans consentement explicite. Discutez de ces scénarios avec votre équipe avant de commencer le parcours."
            },
            {
              "title": "Conservation et usage futur",
              "content": "Les embryons peuvent être conservés très longtemps : il n'y a aucune preuve que la durée de conservation affecte les résultats, et des bébés sont nés d'embryons congelés depuis plus de 25 ans. En France, dans le cadre du parcours AMP, la conservation des embryons surnuméraires est prise en charge par la Sécurité sociale au titre de l'ALD. Au-delà du parcours (après une naissance vivante ou un abandon du projet parental), une décision annuelle écrite est demandée : poursuivre la conservation hors ALD (souvent payante, de l'ordre de 50 à 100 € / an au CECOS), donner à un autre couple, donner à la recherche, ou demander la destruction."
            },
            {
              "title": "Le processus de transfert",
              "content": "Quand tu es prête à utiliser tes embryons, le processus de transfert est bien plus simple que la ponction. C'est une procédure rapide (environ 10 minutes) qui ne nécessite pas d'anesthésie. Ta médecin place l'embryon dans ton utérus à l'aide d'un fin cathéter guidé par échographie. La plupart des patientes reprennent leurs activités normales le jour même."
            }
          ],
          "references": [
            {
              "title": "Human pregnancy following cryopreservation, thawing and transfer of an eight-cell embryo",
              "authors": "Trounson A, Mohr L.",
              "journal": "Nature",
              "year": 1983,
              "url": "https://www.nature.com/articles/305707a0",
              "evidenceLevel": "observational"
            },
            {
              "title": "Oocyte, embryo and blastocyst cryopreservation in ART: systematic review and meta-analysis comparing slow-freezing versus vitrification",
              "authors": "Rienzi L, Gracia C, Maggiulli R, et al.",
              "journal": "Human Reproduction Update",
              "year": 2017,
              "url": "https://academic.oup.com/humupd/article/23/2/139/2982525",
              "evidenceLevel": "meta-analysis"
            },
            {
              "title": "Code de la santé publique, articles L2141-3 et L2141-4 (conservation et devenir des embryons)",
              "authors": "Légifrance",
              "url": "https://www.legifrance.gouv.fr/codes/section_lc/LEGITEXT000006072665/LEGISCTA000006171144/",
              "evidenceLevel": "official"
            },
            {
              "title": "Embryons surnuméraires : conservation, don, recherche, arrêt",
              "authors": "Agence de la biomédecine",
              "url": "https://www.procreation-medicale.fr/vos-questions/devenir-gametes-embryons-apres-31-mars-2025/",
              "evidenceLevel": "official"
            }
          ]
        }
      }
    },
    {
      "id": "moon-article-cycle-process",
      "locale": "fr",
      "variant": {
        "title": "Ce qui se passe pendant un cycle",
        "subtitle": "Quatre phases, deux semaines, un objectif.",
        "body": {
          "introduction": "Le processus",
          "quickSummary": [
            {
              "title": "10 à 14 jours au total.",
              "description": "Le cycle entier, du monitorage de début de cycle à la ponction, prend généralement environ deux semaines."
            },
            {
              "title": "Quatre phases.",
              "description": "Monitorage de début de cycle, stimulation, déclenchement, et ponction, chacune avec ses étapes et son timing spécifiques."
            },
            {
              "title": "Suivi régulier.",
              "description": "Attends-toi à des visites en clinique tous les 2 à 3 jours pendant la stimulation pour des prises de sang et échographies."
            }
          ],
          "sections": [
            {
              "title": "Phase 1 : Monitorage de début de cycle (J2-J3)",
              "content": "Au jour 2 ou 3 de tes règles, tu te rendras à la clinique pour une prise de sang et une échographie endovaginale. Ta médecin vérifie tes niveaux hormonaux (œstradiol, FSH, LH) et compte les petits follicules visibles sur chaque ovaire (comptage des follicules antraux). Ce monitorage de début de cycle confirme que tu es prête à commencer la stimulation."
            },
            {
              "title": "Phase 2 : Stimulation",
              "content": "C'est l'événement principal : généralement 8 à 12 jours d'injections hormonales quotidiennes. Les médicaments (gonadotrophines comme Gonal-F, Follistim, ou Menopur) stimulent tes ovaires à développer plusieurs follicules en même temps, plutôt que l'ovocyte unique que ton corps produirait normalement.",
              "bulletPoints": [
                "Visites en clinique tous les 2 à 3 jours pour le suivi",
                "Prise de sang et échographie endovaginale à chaque visite",
                "Doses de médicaments ajustées selon ta réponse"
              ],
              "diagram": {
                "label": "Calendrier de croissance des follicules"
              }
            },
            {
              "title": "Prévenir l'ovulation prématurée",
              "content": "Tu peux aussi prendre un antagoniste de la GnRH (comme Cetrotide ou Ganirelix) à partir du jour 5 ou 6 pour prévenir une ovulation prématurée. Cela garantit que les ovocytes restent dans les follicules jusqu'à la ponction."
            },
            {
              "title": "Phase 3 : Déclenchement",
              "content": "Quand les plus gros follicules atteignent environ 18 à 20 mm, ta médecin prescrit l'injection de déclenchement de l'ovulation. Le timing est précis (généralement à une heure très spécifique en soirée), parce que la ponction doit avoir lieu exactement 36 heures plus tard. L'injection de déclenchement (hCG ou Lupron) provoque la maturation finale des ovocytes."
            },
            {
              "title": "Phase 4 : Ponction",
              "content": "C'est une procédure ambulatoire courte réalisée sous sédation légère (tu seras endormie mais n'auras pas besoin d'anesthésie générale). Guidée par échographie, ta médecin insère une fine aiguille à travers la paroi vaginale pour atteindre chaque follicule et aspirer le liquide contenant l'ovocyte. Toute la procédure dure 15 à 25 minutes."
            },
            {
              "title": "Récupération",
              "content": "La récupération est généralement rapide. Tu peux te sentir ballonnée, avoir des crampes, ou être fatiguée pendant quelques jours. La plupart des personnes prennent le jour de la ponction de repos et reprennent leurs activités normales en 1 à 2 jours. Ta clinique t'appellera le lendemain avec les résultats : combien d'ovocytes ont été recueillis et combien étaient matures."
            }
          ],
          "references": [
            {
              "title": "ESHRE guideline: ovarian stimulation for IVF/ICSI",
              "authors": "ESHRE Guideline Group on Ovarian Stimulation",
              "journal": "Human Reproduction Open",
              "year": 2020,
              "url": "https://academic.oup.com/hropen/article/2020/2/hoaa009/5826933",
              "evidenceLevel": "guideline"
            },
            {
              "title": "Gonadotrophin-releasing hormone antagonists for assisted reproductive technology",
              "authors": "Al-Inany HG, Youssef MA, Ayeleke RO, et al.",
              "journal": "Cochrane Database of Systematic Reviews",
              "year": 2016,
              "url": "https://www.cochranelibrary.com/cdsr/doi/10.1002/14651858.CD001750.pub4/full",
              "evidenceLevel": "meta-analysis"
            },
            {
              "title": "IVF: In vitro fertilization (process overview)",
              "authors": "Mayo Clinic",
              "url": "https://www.mayoclinic.org/tests-procedures/in-vitro-fertilization/about/pac-20384716",
              "evidenceLevel": "reference"
            }
          ]
        }
      }
    },
    {
      "id": "moon-article-pgt-testing",
      "locale": "fr",
      "variant": {
        "title": "Test génétique préimplantatoire : PGT-A et DPI",
        "subtitle": "Ce que c'est, ce que dit la science récente, et le cadre français spécifique.",
        "body": {
          "introduction": "Choix difficile",
          "quickSummary": [
            {
              "title": "Deux types très différents.",
              "description": "Le PGT-A dépiste les aneuploïdies (nombre de chromosomes) ; le DPI (PGT-M, PGT-SR) cible une maladie génétique connue. Ils ne sont pas équivalents et n'ont pas le même cadre légal."
            },
            {
              "title": "En France, le PGT-A n'est pas autorisé en routine.",
              "description": "Seul le DPI est autorisé, exclusivement en CPDPN agréé, pour des maladies « d'une particulière gravité »."
            },
            {
              "title": "Le bénéfice global du PGT-A est débattu.",
              "description": "Les méta-analyses Cochrane et l'essai randomisé STAR n'ont pas démontré d'amélioration du taux de naissance vivante chez les patientes tout-venant."
            }
          ],
          "sections": [
            {
              "title": "PGT-A vs DPI : la distinction clé",
              "content": "Le PGT-A (test génétique préimplantatoire pour l'aneuploïdie) vérifie les embryons pour des anomalies du nombre de chromosomes (par exemple trisomie 21, monosomie X). Il ne cherche pas une maladie monogénique précise. Le DPI (diagnostic préimplantatoire, équivalent international du PGT-M et PGT-SR) cible une mutation connue chez les parents, comme la mucoviscidose, la chorée de Huntington, ou une translocation équilibrée. Cette distinction est cruciale pour comprendre ce qui est accessible où, et pour qui."
            },
            {
              "title": "Comment fonctionne la biopsie",
              "content": "Le test nécessite une petite biopsie de 5 à 10 cellules du trophectoderme, la couche externe du blastocyste qui devient le placenta. Cette biopsie a lieu au jour 5 ou 6, et l'embryon est ensuite congelé pendant que les cellules sont envoyées à un laboratoire de génétique. Les résultats prennent 1 à 2 semaines et classifient les embryons comme euploïdes (chromosomes normaux), aneuploïdes (anormaux), ou mosaïques (un mélange)."
            },
            {
              "title": "Le cadre français : ce qui est autorisé",
              "content": "En France, la loi de bioéthique (révisée en 2021) encadre strictement les tests génétiques sur embryon. Le DPI (PGT-M et PGT-SR) est autorisé uniquement dans les Centres Pluridisciplinaires de Diagnostic Prénatal (CPDPN) agréés, et seulement pour des maladies génétiques d'une particulière gravité, sans traitement curatif au moment du diagnostic. Le PGT-A (dépistage des aneuploïdies sans pathologie monogénique connue) n'est pas autorisé en pratique courante en France, contrairement aux États-Unis, à l'Espagne ou à la Belgique.",
              "bulletPoints": [
                "DPI (PGT-M / PGT-SR) : autorisé en CPDPN pour maladie « d'une particulière gravité »",
                "PGT-A pour aneuploïdie : non autorisé en routine en France",
                "Indications acceptées : maladies génétiques familiales graves, translocations équilibrées parentales",
                "Coût : pris en charge à 100 % par la Sécurité sociale si l'indication est validée par le CPDPN"
              ]
            },
            {
              "title": "Ce que dit la science récente sur le PGT-A",
              "content": "Le PGT-A a longtemps été présenté comme un moyen d'améliorer les résultats de FIV. Les données récentes nuancent fortement ce discours. La méta-analyse Cochrane 2020 (Cornelisse et al.) et l'essai randomisé multicentrique STAR (Munné et al., 2019) n'ont pas montré d'amélioration du taux de naissance vivante en intention de traiter chez les patientes tout-venant. Le PGT-A peut réduire le risque de fausse couche par embryon transféré et raccourcir le temps jusqu'à la grossesse pour certaines patientes (âge avancé, FCR, échecs répétés), mais il n'est plus considéré comme bénéfique pour tout le monde."
            },
            {
              "title": "Qui en bénéficie le plus (dans les pays où c'est autorisé)",
              "content": "Le profil de patiente où le PGT-A reste argumentable : âge maternel avancé (≥ 38 ans), antécédents de fausses couches à répétition, échecs d'implantation répétés, ou anomalies chromosomiques parentales connues. Pour les patientes de moins de 35 ans sans facteur de risque, la balance bénéfice-risque est défavorable selon les recommandations ASRM 2024 et l'essai STAR."
            },
            {
              "title": "Limites techniques",
              "content": "Le PGT-A teste le trophectoderme, pas la masse cellulaire interne (qui devient le bébé). Dans certains cas, la génétique de ces deux populations cellulaires peut différer, conduisant à des faux positifs ou faux négatifs. Les embryons mosaïques (mélange de cellules normales et anormales) compliquent encore l'interprétation : certains peuvent donner des grossesses en bonne santé, mais beaucoup de cliniques recommandent de ne pas les transférer en première intention."
            },
            {
              "title": "Si tu envisages un parcours à l'étranger",
              "content": "Certaines patientes choisissent un parcours à l'étranger pour accéder au PGT-A (Espagne, Belgique, République tchèque). Avant de te lancer : le coût est entièrement à ta charge (compte 3 000 à 5 000 € pour le PGT-A seul, en plus du cycle de FIV), la coordination médicale est plus complexe, et le cadre légal peut différer (notamment sur le devenir des embryons et l'accès aux origines). Discute avec un·e spécialiste en France avant de planifier."
            }
          ],
          "references": [
            {
              "title": "Preimplantation genetic testing for aneuploidies (abnormal number of chromosomes) in in vitro fertilisation",
              "authors": "Cornelisse S, Zagers M, Kostova E, et al.",
              "journal": "Cochrane Database of Systematic Reviews",
              "year": 2020,
              "url": "https://www.cochranelibrary.com/cdsr/doi/10.1002/14651858.CD005291.pub3/full",
              "evidenceLevel": "meta-analysis"
            },
            {
              "title": "Preimplantation genetic testing for aneuploidy versus morphology as selection criteria for single frozen-thawed embryo transfer in good-prognosis patients: a multicenter randomized clinical trial (STAR)",
              "authors": "Munné S, Kaplan B, Frattarelli JL, et al.",
              "journal": "Fertility and Sterility",
              "year": 2019,
              "url": "https://www.fertstert.org/article/S0015-0282(19)32173-3/fulltext",
              "evidenceLevel": "rct"
            },
            {
              "title": "The nature of aneuploidy with increasing age of the female partner: a review of 15,169 consecutive trophectoderm biopsies",
              "authors": "Franasiak JM, Forman EJ, Hong KH, et al.",
              "journal": "Fertility and Sterility",
              "year": 2014,
              "url": "https://www.fertstert.org/article/S0015-0282(13)03303-X/fulltext",
              "evidenceLevel": "cohort"
            },
            {
              "title": "The use of preimplantation genetic testing for aneuploidy (PGT-A): a committee opinion",
              "authors": "Practice Committee of the ASRM and SART",
              "url": "https://www.asrm.org/practice-guidance/practice-committee-documents/use-of-preimplantation-genetic-testing-for-aneuploidy-pgt-a-a-committee-opinion-2024/",
              "evidenceLevel": "guideline"
            },
            {
              "title": "Le diagnostic préimplantatoire (DPI) en France : cadre légal et indications",
              "authors": "Agence de la biomédecine",
              "url": "https://www.agence-biomedecine.fr/fr/diagnostic-preimplantatoire/diagnostic-preimplantatoire",
              "evidenceLevel": "official"
            },
            {
              "title": "Loi n° 2021-1017 du 2 août 2021 relative à la bioéthique",
              "authors": "Légifrance",
              "year": 2021,
              "url": "https://www.legifrance.gouv.fr/loda/id/JORFTEXT000043884384/",
              "evidenceLevel": "official"
            }
          ]
        }
      }
    },
    {
      "id": "moon-article-understanding-numbers",
      "locale": "fr",
      "variant": {
        "title": "Comprendre tes chiffres",
        "subtitle": "Ce que ta prise de sang dit vraiment à ta médecin.",
        "body": {
          "introduction": "AMH, FSH, CFA",
          "quickSummary": [
            {
              "title": "Trois examens clés.",
              "description": "L'AMH, la FSH, et le CFA dessinent ensemble une image de ta réserve ovarienne."
            },
            {
              "title": "Quantité, pas qualité.",
              "description": "Ces examens mesurent combien d'ovocytes tu as, pas leur qualité. La qualité est liée à l'âge."
            },
            {
              "title": "Le contexte compte.",
              "description": "Un chiffre seul ne veut pas dire grand-chose. Ta médecin interprète les résultats avec ton âge et ton historique."
            }
          ],
          "sections": [
            {
              "title": "AMH (hormone anti-müllérienne)",
              "content": "L'AMH est une prise de sang qui peut être faite n'importe quel jour de ton cycle. Elle est produite par les petits follicules de tes ovaires, donc c'est un indicateur direct de ton stock d'ovocytes. Une AMH plus élevée signifie généralement plus d'ovocytes disponibles pour la stimulation.",
              "bulletPoints": [
                "Plage normale : environ 1,0 à 3,5 ng/mL pour les femmes en âge de procréer",
                "Peut être prélevée n'importe quel jour du cycle",
                "Des valeurs plus élevées suggèrent plus d'ovocytes disponibles pour la stimulation"
              ],
              "diagram": {
                "label": "Déclin de la réserve ovarienne avec l'âge"
              }
            },
            {
              "title": "FSH (hormone folliculo-stimulante)",
              "content": "La FSH se mesure au jour 2 ou 3 de ton cycle. C'est l'hormone que ton cerveau envoie pour dire à tes ovaires de commencer à développer les ovocytes. Une FSH élevée peut indiquer que ton cerveau travaille plus dur pour stimuler les ovaires, un signe de réserve diminuée. L'idéal est en dessous de 10 mUI/mL."
            },
            {
              "title": "CFA (comptage des follicules antraux)",
              "content": "Le CFA se fait par échographie endovaginale, aussi au jour 2 ou 3. La médecin compte les petits follicules au repos (2 à 10 mm) visibles sur chaque ovaire. Chaque follicule antral contient potentiellement un ovocyte qui pourrait être recueilli. Un total de 10 à 20 sur les deux ovaires est considéré comme normal."
            },
            {
              "title": "Ce que ces examens ne te disent pas",
              "content": "La qualité des ovocytes. Il n'y a pas de test direct pour la qualité : elle est principalement liée à l'âge. Une femme de 28 ans avec une AMH basse a généralement une meilleure qualité d'ovocytes qu'une femme de 40 ans avec une AMH élevée. La qualité est finalement évaluée indirectement, à travers les taux de fécondation et le développement embryonnaire."
            },
            {
              "title": "Ne panique pas pour un seul chiffre",
              "content": "Ces examens s'interprètent mieux ensemble, dans le contexte de ton âge et de ton historique médical. L'AMH peut fluctuer entre les cycles, et différents labos peuvent donner des résultats différents. La plage de référence de l'AMH varie également selon l'âge : la valeur médiane décline d'environ 50 % entre 25 et 35 ans (La Marca 2014). Ce qui compte le plus, c'est le tableau global que ta médecin compose."
            }
          ],
          "references": [
            {
              "title": "Individualization of controlled ovarian stimulation in IVF using ovarian reserve markers: from theory to practice",
              "authors": "La Marca A, Sunkara SK.",
              "journal": "Human Reproduction Update",
              "year": 2014,
              "url": "https://academic.oup.com/humupd/article/20/1/124/2952718",
              "evidenceLevel": "meta-analysis"
            },
            {
              "title": "Testing and interpreting measures of ovarian reserve: a committee opinion",
              "authors": "Practice Committee of the ASRM",
              "journal": "Fertility and Sterility",
              "year": 2020,
              "url": "https://www.asrm.org/practice-guidance/practice-committee-documents/testing-and-interpreting-measures-of-ovarian-reserve-a-committee-opinion-2020/",
              "evidenceLevel": "guideline"
            },
            {
              "title": "Recommandations pour la pratique clinique : bilan d'infertilité",
              "authors": "Collège national des gynécologues et obstétriciens français (CNGOF)",
              "url": "https://www.cngof.fr/pratiques-cliniques/recommandations-pour-la-pratique-clinique",
              "evidenceLevel": "guideline"
            }
          ]
        }
      }
    },
    {
      "id": "moon-article-pick-clinic",
      "locale": "fr",
      "variant": {
        "title": "Comment choisir la bonne clinique",
        "subtitle": "Les questions que la plupart des gens oublient de poser.",
        "body": {
          "introduction": "Recherche de clinique",
          "quickSummary": [
            {
              "title": "Regarde au-delà des taux de réussite.",
              "description": "Les chiffres bruts peuvent tromper : les cliniques avec des taux plus bas prennent parfois les cas plus difficiles."
            },
            {
              "title": "Le labo compte le plus.",
              "description": "La qualité du labo d'embryologie varie beaucoup et impacte directement tes résultats."
            },
            {
              "title": "Fais confiance à ton instinct.",
              "description": "Tu dois te sentir écoutée, respectée, et informée par ton équipe médicale."
            }
          ],
          "sections": [
            {
              "title": "Commence par les chiffres officiels",
              "content": "En France, l'Agence de la biomédecine publie chaque année un Rapport médical et scientifique avec les taux de réussite par centre d'AMP, accessible à rams.agence-biomedecine.fr. Aux États-Unis, l'équivalent est SART.org (Society for Assisted Reproductive Technology). Mais dans les deux cas, les taux bruts peuvent tromper : une clinique avec des chiffres plus bas peut prendre en charge les cas plus durs, tandis qu'une avec des taux stellaires peut sélectionner les patientes plus faciles. Cherche les taux par tranche d'âge et par indication, pas le chiffre global."
            },
            {
              "title": "Questions pour ta première consultation",
              "content": "Ta première consultation est ta chance d'évaluer à la fois la clinique et la médecin. Viens préparée avec des questions précises qui révéleront comment la clinique fonctionne et si c'est un bon match pour toi.",
              "bulletPoints": [
                "Quel protocole de stimulation recommanderiez-vous pour moi ?",
                "Combien d'ovocytes attendez-vous selon mes chiffres ?",
                "Quel est votre taux d'annulation ?",
                "Quelle est votre politique de suivi le week-end ?",
                "Combien d'embryologistes ont-vous dans l'équipe ?"
              ]
            },
            {
              "title": "Le laboratoire d'embryologie",
              "content": "Le laboratoire d'embryologie compte énormément. C'est là que tes ovocytes deviennent des embryons, et la qualité du labo varie beaucoup. Demande leur taux de conversion en blastocyste, leur taux de survie après congélation-décongélation, et s'ils ont un directeur de labo dédié."
            },
            {
              "title": "Emplacement et praticité",
              "content": "Ne te contente pas de la clinique la plus proche. Une clinique avec de meilleurs taux de réussite pour ton profil spécifique peut faire la différence entre un cycle et trois. Cela dit, la praticité compte aussi : tu y iras tous les 2 à 3 jours pendant la stimulation, alors prends en compte le temps de trajet."
            },
            {
              "title": "Style de communication",
              "content": "Certaines cliniques t'assignent une infirmière coordinatrice dédiée ; d'autres utilisent une approche d'équipe. Certaines ont des portails patients avec des résultats en temps réel ; d'autres t'appellent. Aucun n'est objectivement meilleur, mais pense à ce qui marche pour tes préférences de communication."
            },
            {
              "title": "Transparence sur les coûts",
              "content": "La transparence des coûts est un bon signe. Les bonnes cliniques fournissent des décompositions détaillées des coûts dès le départ, médicaments, suivi, procédures, anesthésie, et stockage inclus. Méfie-toi des cliniques vagues sur les prix ou qui te surprennent avec des frais cachés."
            },
            {
              "title": "Fais confiance à ton instinct",
              "content": "Tu dois te sentir écoutée, respectée, et informée. Si une médecin balaie tes questions ou bâcle ta consultation, c'est un signal d'alarme, peu importe la qualité de ses chiffres."
            }
          ],
          "references": [
            {
              "title": "Centres d'AMP autorisés et indicateurs de qualité en France",
              "authors": "Agence de la biomédecine",
              "url": "https://www.procreation-medicale.fr/les-centres-autorises/",
              "evidenceLevel": "official"
            },
            {
              "title": "Rapport médical et scientifique annuel : taux de réussite par centre",
              "authors": "Agence de la biomédecine",
              "url": "https://rams.agence-biomedecine.fr/",
              "evidenceLevel": "official"
            },
            {
              "title": "SART Clinic Summary Report : taux par clinique aux États-Unis",
              "authors": "Society for Assisted Reproductive Technology",
              "url": "https://www.sart.org/",
              "evidenceLevel": "reference"
            }
          ]
        }
      }
    },
    {
      "id": "moon-article-supplements",
      "locale": "fr",
      "variant": {
        "title": "Les compléments qui comptent vraiment",
        "subtitle": "Oublie le marketing. Voici ce que la recherche soutient.",
        "body": {
          "introduction": "Fondé sur les preuves",
          "quickSummary": [
            {
              "title": "Commence tôt.",
              "description": "La plupart des compléments ont besoin de 2 à 3 mois pour faire effet. Commence bien avant ton cycle."
            },
            {
              "title": "Qualité plutôt que quantité.",
              "description": "Concentre-toi sur les 4 ou 5 qui ont de vraies preuves plutôt qu'une douzaine non prouvés."
            },
            {
              "title": "Parle à ta médecin d'abord.",
              "description": "Les compléments peuvent interagir avec les médicaments et certains ne sont adaptés que pour des diagnostics précis."
            }
          ],
          "sections": [
            {
              "title": "CoQ10 (Ubiquinol)",
              "subtitle": "600 mg/jour, preuves les plus solides pour la qualité ovocytaire",
              "content": "Le CoQ10 a les preuves les plus solides pour l'amélioration de la qualité ovocytaire. Il soutient la fonction mitochondriale dans les ovocytes, ce qui est critique pour la bonne division cellulaire. Commence au moins 2 à 3 mois avant ton cycle pour lui laisser le temps d'agir."
            },
            {
              "title": "Vitamine prénatale avec méthylfolate",
              "content": "Une vitamine prénatale avec méthylfolate (pas d'acide folique synthétique) est essentielle. Le méthylfolate est la forme bioactive que ton corps peut utiliser directement, et environ 30 à 40 % des personnes ont des variants du gène MTHFR qui leur rendent difficile la conversion de l'acide folique. Le folate est crucial pour prévenir les anomalies du tube neural et soutenir le développement embryonnaire précoce."
            },
            {
              "title": "Vitamine D",
              "subtitle": "2 000 à 4 000 UI par jour",
              "content": "La vitamine D joue un rôle dans la régulation hormonale et l'implantation. Les études montrent que les femmes avec des niveaux suffisants de vitamine D ont des taux de grossesse plus élevés en FIV. Fais doser ton taux : beaucoup de personnes sont carencées, surtout dans les climats nordiques."
            },
            {
              "title": "Acides gras oméga-3",
              "subtitle": "DHA + EPA, au moins 1 000 mg combinés",
              "content": "Les oméga-3 soutiennent la production hormonale et réduisent l'inflammation. Ils sont aussi essentiels pour le développement du cerveau du fœtus une fois enceinte. Choisis une huile de poisson de haute qualité ou un complément à base d'algues."
            },
            {
              "title": "DHEA",
              "subtitle": "25 mg trois fois par jour, uniquement sous supervision médicale",
              "content": "Le DHEA est parfois recommandé pour les femmes avec une réserve ovarienne diminuée. Les preuves sont mitigées mais certaines études montrent qu'il peut améliorer le nombre et la qualité des ovocytes. Ne le prends que sous la supervision de ta médecin, car c'est un précurseur hormonal."
            },
            {
              "title": "Ce qu'il faut éviter",
              "content": "La plupart des compléments commercialisés pour la « fertilité » ont peu de preuves. La gelée royale, la maca, et les mélanges étiquetés fertilité sont largement non prouvés. Concentre-toi sur les bases ci-dessus. Plus de compléments ne veut pas dire de meilleurs résultats, juste plus de pilules et plus d'argent dépensé."
            }
          ]
        }
      }
    },
    {
      "id": "moon-article-lab-grown-eggs",
      "locale": "fr",
      "variant": {
        "title": "Ovocytes cultivés en labo : la percée qui réécrit la fertilité",
        "subtitle": "Des scientifiques ont transformé des cellules de peau en ovocytes viables. Ce que ça veut dire pour toi.",
        "body": {
          "introduction": "À la une",
          "quickSummary": [
            {
              "title": "De la peau à l'ovocyte.",
              "description": "Des chercheurs ont créé avec succès des ovocytes fonctionnels à partir de cellules de peau de souris en utilisant la technologie iPSC."
            },
            {
              "title": "10 à 15 ans avant.",
              "description": "La plupart des experts estiment que la disponibilité clinique est encore à au moins une décennie pour les humains."
            },
            {
              "title": "Pas encore disponible.",
              "description": "Cette technologie est encore aux premiers stades de recherche et pas disponible pour usage clinique."
            }
          ],
          "sections": [
            {
              "title": "La percée de Kyushu",
              "content": "Dans une étude marquante publiée en 2023 dans Nature (Murakami et al.), des chercheurs de l'université de Kyushu au Japon, dirigés par Katsuhiko Hayashi, ont créé avec succès des ovocytes fonctionnels à partir de cellules de peau de souris mâles en utilisant la technologie des cellules souches pluripotentes induites (iPSC). Les ovocytes obtenus ont été fécondés et ont produit une descendance saine et fertile. C'est la première démonstration claire chez les mammifères que des gamètes femelles peuvent être créés en laboratoire à partir de cellules somatiques. Le résultat reste limité à la souris, et la transposition à l'humain reste un défi technique et éthique majeur."
            },
            {
              "title": "Qu'est-ce que la gamétogenèse in vitro (IVG) ?",
              "content": "Cette technique, appelée gamétogenèse in vitro (IVG), pourrait à terme permettre à n'importe qui de produire des ovocytes à partir d'un simple échantillon de peau ou de sang, quel que soit l'âge ou la fonction ovarienne. Pour les patientes de fertilité, cela signifierait un stock d'ovocytes essentiellement illimité, sans stimulation hormonale ni ponction chirurgicale. Le sujet relève aujourd'hui des preuves émergentes : c'est de la science de pointe, pas une option clinique."
            },
            {
              "title": "La course à l'application humaine",
              "content": "Plusieurs entreprises de biotech se lancent maintenant dans la traduction de cette technologie de la souris à l'humain. Vérifie toujours les sources primaires (publications dans des revues à comité de lecture) plutôt que les communiqués de presse, car ce champ génère beaucoup d'annonces avant que les données soient publiées et reproduites."
            },
            {
              "title": "Calendrier et obstacles",
              "content": "Le calendrier d'usage clinique est incertain : la plupart des experts estiment qu'il faudra 10 à 15 ans avant que l'IVG humaine soit disponible en clinique. Plusieurs obstacles importants demeurent : garantir la sécurité génétique, naviguer l'approbation réglementaire, et répondre aux questions éthiques profondes que cette technologie soulève."
            },
            {
              "title": "Ce que ça veut dire pour toi maintenant",
              "content": "Probablement pas grand-chose pour tes décisions de traitement actuelles. Mais c'est un signe que la science de la fertilité avance vite, et que des options qui semblent de la science-fiction aujourd'hui pourraient être de routine dans une génération."
            },
            {
              "title": "Reste sur la technologie éprouvée",
              "content": "En attendant, la meilleure approche est toujours de travailler avec des technologies éprouvées et établies (congélation d'ovocytes, cryoconservation d'embryons, et FIV), tout en gardant un œil sur ces développements passionnants."
            }
          ],
          "references": [
            {
              "title": "Generation of functional oocytes from male mice in vitro",
              "authors": "Murakami K, Hamazaki N, Hamada N, et al.",
              "journal": "Nature",
              "year": 2023,
              "url": "https://www.nature.com/articles/s41586-023-05834-x",
              "evidenceLevel": "observational"
            },
            {
              "title": "Mammalian in vitro gametogenesis",
              "authors": "Saitou M, Hayashi K.",
              "journal": "Science",
              "year": 2021,
              "url": "https://www.science.org/doi/10.1126/science.aaz6830",
              "evidenceLevel": "review"
            },
            {
              "title": "Ethical issues in in vitro gametogenesis",
              "authors": "Mertes H, Segers S.",
              "journal": "Bioethics",
              "year": 2017,
              "url": "https://onlinelibrary.wiley.com/doi/10.1111/bioe.12343",
              "evidenceLevel": "expert-opinion"
            }
          ]
        }
      }
    },
    {
      "id": "moon-article-eggs-vs-embryos",
      "locale": "fr",
      "variant": {
        "title": "Ovocytes vs embryons : que congeler ?",
        "subtitle": "Les compromis entre la congélation d'ovocytes seuls et la création d'embryons.",
        "body": {
          "introduction": "Choix difficile",
          "quickSummary": [
            {
              "title": "Ovocytes = flexibilité.",
              "description": "Les ovocytes congelés ne demandent pas de partenaire ou de donneur maintenant, et tu choisis comment les utiliser plus tard."
            },
            {
              "title": "Embryons = certitude.",
              "description": "Tu sais déjà que la fécondation a marché. Taux de survie après décongélation plus élevés et option du test génétique."
            },
            {
              "title": "Pas de mauvaise réponse.",
              "description": "Le meilleur choix dépend de ta relation, de ton âge, et de ton confort face à l'incertitude."
            }
          ],
          "sections": [
            {
              "title": "La différence fondamentale",
              "content": "Les deux chemins commencent pareil : stimulation ovarienne, suivi, et ponction ovocytaire. La différence est ce qui se passe après la ponction. Avec la congélation d'ovocytes, tes ovocytes matures sont vitrifiés immédiatement. Avec la congélation d'embryons, les ovocytes sont d'abord fécondés avec du sperme, cultivés 5 à 7 jours, et les embryons obtenus sont congelés."
            },
            {
              "title": "Taux de survie après décongélation",
              "content": "Les embryons ont un léger avantage : plus de 95 % de survie après décongélation contre 85 à 90 % pour les ovocytes. C'est parce que les embryons sont multicellulaires et plus résistants au processus de vitrification. Concrètement, si tu congèles 12 ovocytes, tu peux t'attendre à ce que 10 ou 11 survivent à la décongélation. Si ces mêmes ovocytes avaient été fécondés et que 8 étaient devenus des embryons, presque tous les 8 survivraient à la décongélation."
            },
            {
              "title": "La fécondation, un filtre",
              "content": "Quand tu crées des embryons, tu apprends tout de suite si la fécondation marche. Tous les ovocytes ne fécondent pas, et tous les ovocytes fécondés ne se développent pas jusqu'au blastocyste. Avec des ovocytes congelés, tu ne le sauras pas avant des années, quand tu les décongèleras pour les utiliser. Pour certaines personnes, supprimer cette incertitude est le plus grand avantage de la congélation d'embryons."
            },
            {
              "title": "Test génétique (PGT-A)",
              "content": "Seuls les embryons peuvent être testés pour des anomalies chromosomiques avant le transfert. Le PGT-A dépiste chaque embryon pour le bon nombre de chromosomes, ce qui aide à sélectionner celui qui a le plus de chances de mener à une grossesse en bonne santé. C'est particulièrement pertinent après 35 ans, quand le taux d'anomalies chromosomiques augmente."
            },
            {
              "title": "L'argument de la flexibilité",
              "content": "Les ovocytes congelés sont entièrement à toi. Il n'y a pas de complications légales si ta relation change. Tu peux décider plus tard d'utiliser le sperme d'un partenaire, du sperme d'un donneur, ou de ne pas les utiliser du tout. Les embryons, en revanche, relèvent en France d'un dispositif d'autorisation parentale conjointe (article L2141-3 du Code de la santé publique) : leur transfert, leur conservation, leur don ou leur destruction nécessitent le consentement écrit des deux membres du couple. En cas de séparation, de désaccord ou de décès, le transfert ne peut pas avoir lieu sans consentement explicite des deux parents."
            },
            {
              "title": "Quand les ovocytes ont plus de sens",
              "content": "Tu es célibataire ou pas sûre de ton partenaire actuel. Tu veux un maximum de flexibilité pour l'avenir. Tu as moins de 35 ans et un bon rendement ovocytaire attendu. Tu veux éviter la complexité légale des embryons partagés.",
              "bulletPoints": [
                "Célibataire ou pas sûre de son partenaire",
                "Veut un maximum de flexibilité future",
                "Moins de 35 ans avec une bonne réserve ovarienne",
                "Préfère éviter les accords légaux"
              ]
            },
            {
              "title": "Quand les embryons ont plus de sens",
              "content": "Tu as un partenaire engagé. Tu veux les meilleurs taux de réussite possibles par unité congelée. Tu as plus de 35 ans et veux maximiser tes chances. Tu veux l'option de tester les embryons génétiquement.",
              "bulletPoints": [
                "Partenaire engagé ou donneur choisi",
                "Veut la certitude de savoir que la fécondation a marché",
                "Plus de 35 ans ou inquiète de la qualité ovocytaire",
                "Intéressée par le test génétique PGT-A"
              ]
            },
            {
              "title": "Peut-on faire les deux ?",
              "content": "Oui. Certaines patientes congèlent une partie de leurs ovocytes et fécondent le reste pour créer des embryons. Cette approche de hedging donne à la fois flexibilité et certitude. Discute avec ta médecin pour savoir si ton rendement attendu rend cela praticable."
            }
          ],
          "references": [
            {
              "title": "Oocyte, embryo and blastocyst cryopreservation in ART: systematic review and meta-analysis comparing slow-freezing versus vitrification",
              "authors": "Rienzi L, Gracia C, Maggiulli R, et al.",
              "journal": "Human Reproduction Update",
              "year": 2017,
              "url": "https://academic.oup.com/humupd/article/23/2/139/2982525",
              "evidenceLevel": "meta-analysis"
            },
            {
              "title": "Evidence-based outcomes after oocyte cryopreservation for donor oocyte IVF and planned oocyte cryopreservation",
              "authors": "Practice Committee of the ASRM",
              "journal": "Fertility and Sterility",
              "year": 2018,
              "url": "https://www.asrm.org/practice-guidance/practice-committee-documents/",
              "evidenceLevel": "guideline"
            },
            {
              "title": "Code de la santé publique, article L2141-3 (devenir des embryons surnuméraires)",
              "authors": "Légifrance",
              "url": "https://www.legifrance.gouv.fr/codes/article_lc/LEGIARTI000043898313/",
              "evidenceLevel": "official"
            }
          ]
        }
      }
    }
  ]
}
